import type { RequestConfig } from '@customTypes/index';
import type { ContractTermsDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetClubProfileContractTermsRequest = {
  clubId: string;
};

export type GetClubProfileContractTermsParams =
  RequestConfig<GetClubProfileContractTermsRequest>;

export const getClubProfileContractTerms = async ({
  params,
  config
}: GetClubProfileContractTermsParams) =>
  api.get<ContractTermsDto>(
    `/api/ClubProfile/contract-terms/${params.clubId}`,
    config
  );
